<ng-container *transloco="let t">
  <main
    class="search-view"
    [class.rtl]="rtlMode$ | async"
    [class.single-header]="(biggerThan$ | async)?.mobileL"
    [class.widescreen]="(biggerThan$ | async)?.mobileL">
    <div #mainAppScroll class="wrapper scroll" id="mainAppScroll" cdk-scrollable>
      <!-- NAV_BAR Desktop-->
      <app-navigation-bar *ngIf="(biggerThan$ | async)?.mobileL" [centerMode]="true" />
      <app-featured-breadcrumbs
        [collectionMode]="true"
        [product]="(search$ | async)?.[0] || null"
        [category]="(searchOptions$ | async)?.category?.[0] || null"
        [brand]="(searchOptions$ | async)?.brand?.[0] || null"
        [model]="(searchOptions$ | async)?.model?.[0] || null"></app-featured-breadcrumbs>
      <!-- MOBILE FILTERS -->
      <ng-container *ngIf="(lessThan$ | async)?.md === true">
        <app-collection-title
          [product]="(search$ | async)?.[0] || null"
          [category]="(searchOptions$ | async)?.category?.[0] || null"
          [brand]="(searchOptions$ | async)?.brand?.[0] || null"
          [model]="(searchOptions$ | async)?.model?.[0] || null"></app-collection-title>

        <app-featured-filters-toolbar
          class="filters-toolbar"
          [phoneFilterOptions]="phoneFilters$ | async"
          (filterPhoneSortByChanged)="onFilterPhoneSortByChanged($event)"
          (phoneFilterOptionsByChanged)="onPhoneFiltersChanged($event)">
        </app-featured-filters-toolbar>
      </ng-container>

      <!-- HIGHLIGHTS -->
      <section class="highlights-banner" *ngIf="(biggerThan$ | async)?.sm === true">
        <app-home-highlights [blueMode]="true" [centerAlign]="true"></app-home-highlights>
      </section>
      <span class="fixed-space-24" aria-hidden="true"></span>
      <!-- TITLE AND SORTING -->
      <section
        *ngIf="(biggerThan$ | async)?.sm === true"
        class="popsy-block flex justify-between p-16 align-end">
        <app-collection-title
          [product]="(search$ | async)?.[0] || null"
          [category]="(searchOptions$ | async)?.category?.[0] || null"
          [brand]="(searchOptions$ | async)?.brand?.[0] || null"
          [model]="(searchOptions$ | async)?.model?.[0] || null"></app-collection-title>
        <popsy-sort-by-filter
          class="sort-button"
          [loading]="loading$ | async"
          [value]="(phoneFilters$ | async)?.sortBy"
          (sortByChanged)="onFilterPhoneSortByChanged($event)"></popsy-sort-by-filter>
      </section>

      <!-- // show brand selector if no model collection page -->
      @if ((searchOptions$ | async)?.model?.length === 0) {
        <app-product-brand-selector
          [phoneFilterOptions]="phoneFilters$ | async"
          (filterBrandChanged)="onFilterBrandChanged($event)"
          [pillMode]="true"></app-product-brand-selector>
      }

      <!-- CONTENT -->
      <div class="content">
        <div class="content-wrapper" [class.mobile]="(lessThan$ | async)?.sm">
          <ng-container *ngIf="(lessThan$ | async)?.md !== true">
            <app-featured-phone-filters-sidebar
              class="filters-sidebar"
              [phoneFilterOptions]="phoneFilters$ | async"
              [allCollapsed]="
                !(hasSearchOptions$ | async) || !(searchOptions$ | async)?.model
              "
              (filterPhoneSortByChanged)="onFilterPhoneSortByChanged($event)"
              (filterPhoneSeriesChanged)="onFilterProductSeriesChanged($event)"
              (filterPhoneModelsChanged)="onFilterPhoneModelsChanged($event)"
              (filterProductBrandChanged)="onFilterProductBrandChanged($event)"
              (filterProductCpuChanged)="onFilterProductCpuChanged($event)"
              (filterProductGraphicsChanged)="onFilterProductGraphicsChanged($event)"
              (filterProductLaunchDateChanged)="onFilterProductLaunchDateChanged($event)"
              (filterProductRamChanged)="onFilterProductRamChanged($event)"
              (filterProductScreenSizeChanged)="onFilterProductScreenSizeChanged($event)"
              (filterProductStorageTypeChanged)="
                onFilterProductStorageTypeChanged($event)
              "
              (filterPhoneColorsChanged)="onFilterPhoneColorsChanged($event)"
              (filterPhoneStoragesChanged)="onFilterPhoneStoragesChanged($event)"
              (filterPhonePriceRangeChanged)="onFilterPhonePriceRangeChanged($event)"
              (filterPhoneClearAll)="onFilterPhoneClearAll($event)">
            </app-featured-phone-filters-sidebar>
            <span class="fixed-space-16" aria-hidden="true"></span>
          </ng-container>

          <!-- SEARCH OPTIONS ? SHOW search_results : SHOW app-phone-brands   -->
          <ng-container *ngIf="hasSearchOptions$ | async">
            <div class="products">
              <ng-container>
                <ng-container
                  *ngIf="
                    (featured$ | async) || (isSearching$ | async) || (loading$ | async)
                  ">
                  <span class="fixed-space-16" aria-hidden="true"></span>
                  <app-product-banner
                    class="full-width"
                    [product]="featured$ | async"></app-product-banner>
                </ng-container>
              </ng-container>

              <span class="fixed-space-16" aria-hidden="true"></span>
              <app-products-collection-grid
                [searchResults]="search$ | async"
                [loading]="(isSearching$ | async) || (loading$ | async)"
                [error]="errorSearching$ | async"
                (filterPhoneClearAll)="onFilterPhoneClearAll($event)">
              </app-products-collection-grid>

              <ng-container *ngIf="hasNextPage$ | async">
                <span class="fixed-space-36" aria-hidden="true"></span>
                <nav class="flex align-center justify-center actions full-width">
                  <button
                    class="load-next popsy-button-secondary"
                    (click)="onLoadNextPage()">
                    {{ t('action_see_more_listings') }}
                  </button>
                </nav>
              </ng-container>
              <span class="fixed-space-64" aria-hidden="true"></span>
            </div>
          </ng-container>
          <!-- PHONE BRANDS -->
          <ng-container *ngIf="!(hasSearchOptions$ | async)">
            <div class="products">
              <!--   <app-featured-best-offers
                class="full-width"
                [category]="(searchOptions$ | async)?.category"
                [brand]="(searchOptions$ | async)?.brand"></app-featured-best-offers> -->
              <app-phone-brands
                [collectionPageMode]="true"
                [category]="(searchOptions$ | async)?.category || []"
                [brand]="(searchOptions$ | async)?.brand || []"></app-phone-brands>
            </div>
          </ng-container>
        </div>

        <!-- SHORT TEXT -->
        <app-collection-title
          [product]="(search$ | async)?.[0] || null"
          [category]="(searchOptions$ | async)?.category?.[0] || null"
          [brand]="(searchOptions$ | async)?.brand?.[0] || null"
          [model]="(searchOptions$ | async)?.model?.[0] || null"
          [showShortText]="true"></app-collection-title>

        <!-- FAQ -->
        <app-product-faq [product]="(search$ | async)?.[0] || null"></app-product-faq>

        <ng-container
          *ngIf="(hasSearchOptions$ | async) && (searchOptions$ | async)?.model">
          <app-featured-reviews-card
            [collectionMode]="true"
            [product]="(search$ | async)?.[0] || null"></app-featured-reviews-card>
        </ng-container>

        <app-footer
          class="footer"
          [class.ssr]="!isBrowser"
          [class.phone]="(lessThan$ | async)?.mobileL"
          [showArrow]="true"></app-footer>
      </div>
    </div>
  </main>
</ng-container>
